import NiceModal from '@ebay/nice-modal-react';
import { Box } from '@mantine/core';

import { useGetPaymentProviders } from '../api/getPaymentProviders';

import { AddModal } from './AddModal';
import { PaymentProvidersTable } from './Table';

import { AddButton, ListLoader } from '@/components';
import { Departments } from '@/types';

type PaymentProvidersListProps = {
  department: Departments;
};

export const PaymentProvidersList = ({ department }: PaymentProvidersListProps) => {
  const { data, isLoading } = useGetPaymentProviders({ department });

  if (isLoading) {
    return <ListLoader />;
  }

  if (!data?.paymentProviders.length) {
    return <ListAddButton department={department} />;
  }

  return (
    <Box style={{ display: 'grid', height: 'calc(100vh - 105px)', gridTemplateRows: 'auto 70px' }}>
      <Box style={{ overflow: 'auto' }}>
        <PaymentProvidersTable department={department} paymentProviders={data.paymentProviders} />
      </Box>
      <ListAddButton department={department} />
    </Box>
  );
};

function ListAddButton({ department }: { department: Departments }) {
  return (
    <AddButton
      size={60}
      onClick={() =>
        NiceModal.show(AddModal, {
          initialValues: {
            department,
            name: '',
            key: '',
            block: '',
          },
        })
      }
    />
  );
}
